import { render, staticRenderFns } from "./ProvisionalOrderList.vue?vue&type=template&id=470ed958&scoped=true&lang=pug"
import script from "./ProvisionalOrderList.vue?vue&type=script&lang=js"
export * from "./ProvisionalOrderList.vue?vue&type=script&lang=js"
import style0 from "./ProvisionalOrderList.vue?vue&type=style&index=0&id=470ed958&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ed958",
  null
  
)

export default component.exports